<template>
  <div class="choose__animation">
    <div class="container">
      <div class="row">
        <div class="column">
          <select v-model="animation" name="animation" v-on:change="onValueChanged">
              <option value="none">none</option>
              <option value="anim-pulse">pulse</option>
              <option value="anim-blink">blink</option>
              <option value="anim-fade-in-out">fade in out</option>
              <option v-if="['hotdot'].indexOf(template) < 0" value="anim-pulse-blink">pulse blink</option>
              <option value="anim-fade-in">fade in</option>
          </select>
        </div>
        <div class="column" v-if="animation !== 'none'">
          <input type="number" title="Animation in ms" step="500" v-model="value" v-on:blur="onValueChanged"/>
        </div>
        <div class="column" v-if="animation !== 'none'">
          <select v-model="mode" name="animation" v-on:change="onValueChanged">
            <option value=""></option>
            <option value="infinite">Infinite</option>
          </select>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "chooseAnimation",
  props: ["modelItem", "template"],
  created() {
    //console.log("chooseAnimation created");
    this.init();
  },
  components: {},
  data() {
    return {
      animation: null,
      value: null,
      mode: null
    };
  },
  watch: {
    "modelItem.value": "init"
  },
  methods: {
    init() {
      //console.log(this.template)
      let val = this.modelItem.value || {};
      // animation like
      this.animation = val.animation || "none";
      // value like time value
      this.value = val.value || 2000;
      // mode 
      this.mode = val.mode || "";
      //console.log(this.template)
    },
    onValueChanged() {
      this.emit();
    },
    emit() {
      this.modelItem.value = {
        animation: this.animation,
        value: this.value,
        mode: this.mode
      };
      this.$emit("pick", this.modelItem.value);
    }
  }
};
</script>
